var ur = window.location.href;
if(ur.includes('/product')){
 jQuery(document).ready(function(){
var f = jQuery('.quantity-swatch.variant__button-label').eq(0).closest('fieldset');
   
   jQuery('.product-single__form').after(f.clone().addClass('below-fieldset'));
   f.addClass('hide');

   $('.below-fieldset .quantity-swatch.variant__button-label').click(function(){
  var v = $(this).closest('.variant-input').attr('data-value');
     $('fieldset.hide .variant-input[data-value="'+v+'"] .quantity-swatch').click()
}); 
}); 
}



var ur = window.location.href;
if(ur.includes('/cart')){

document.addEventListener('DOMContentLoaded', function () {
  
    const dropdown = document.querySelector('.upsell-dropdown');
    const parentElement = document.querySelector('.record-bundle-item');
    const images = document.querySelectorAll('.record-bundle-image');
    const addToCartButtons = document.querySelectorAll('.record-add-to-cart');


  $('.upsell-dropdown').change(function(){
   const selectedIndex = jQuery(this).val();
        // Remove 'selected' class from all images and buttons
        jQuery('.upsell-cont .selected').removeClass('selected');
        
        jQuery(this).closest('.upsell-cont').eq(0).find('.record-add-to-cart').eq(selectedIndex).addClass('selected');
        jQuery(this).closest('.upsell-cont').eq(1).find('.record-add-to-cart').eq(selectedIndex).addClass('selected');

        jQuery(this).closest('.upsell-cont').eq(0).find('.record-bundle-image').eq(selectedIndex).addClass('selected');
        jQuery(this).closest('.upsell-cont').eq(1).find('.record-bundle-image').eq(selectedIndex).addClass('selected');
}); 
    
});
}